import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ColorPicker } from 'antd';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Icon } from '../../ui';
import { throttle } from '../../utils';
import { Tooltip } from '../Tooltip';
import { StyledColorButton, StyledInputColor, StyledWrapper, } from './ColorBullet.style';
export function ColorBullet({ color, variant = 'circle', size = 'Medium', isPicker = false, isSelected = false, readOnly, title, onChange, onChangeComplete, }) {
    const input = useRef(null);
    const [selectedColor, setSelectedColor] = useState(!color || isPicker || color === 'picker' ? '#000000' : color);
    const [isOpened, setIsOpened] = useState(false);
    useEffect(function updateColorWhenPropChanges() {
        setSelectedColor(color);
    }, [color]);
    const handleChange = useCallback(throttle((newColor) => {
        if (readOnly) {
            onChange === null || onChange === void 0 ? void 0 : onChange(color);
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newColor);
        setSelectedColor(newColor);
    }, 150), [onChange, readOnly, color]);
    const handleChangeComplete = useCallback((newColor) => {
        if (readOnly) {
            onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(color);
            return;
        }
        onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(newColor);
        setSelectedColor(newColor);
    }, [onChangeComplete, readOnly, color]);
    const handleClick = useCallback((selectedColor) => {
        if (readOnly) {
            handleChange(selectedColor);
            handleChangeComplete(selectedColor);
            return;
        }
    }, [handleChange, handleChangeComplete, readOnly]);
    const iconSize = useMemo(() => {
        switch (size) {
            case 'Small':
                return 'XXSmall';
            case 'Medium':
                return 'XSmall';
            case 'Large':
                return 'Small';
            default:
                return 'XSmall';
        }
    }, [size]);
    return (_jsx(Tooltip, { text: title, visible: true, children: _jsx(StyledWrapper, { className: "color-bullet-wrapper", children: _jsx(ColorPicker, { defaultFormat: "hex", defaultValue: selectedColor, disabled: readOnly, onChange: (_, hex) => {
                    handleChange(hex);
                }, onChangeComplete: (value) => {
                    handleChangeComplete(value.toHexString());
                }, onOpenChange: (open) => {
                    setIsOpened(open);
                }, children: _jsxs(StyledColorButton, { className: "color-bullet", variant: variant, size: size, isPicker: isPicker, isSelected: isSelected, isReadOnly: readOnly, color: selectedColor, onClick: () => {
                        handleClick(selectedColor);
                    }, children: [_jsx(StyledInputColor, { type: "color", ref: input, defaultValue: selectedColor, isReadOnly: true }), isPicker && (_jsx(Icon, { name: "add-custom-list---16", size: iconSize, angle: isOpened ? 45 : 0 }))] }) }) }) }));
}
//# sourceMappingURL=ColorBullet.js.map